export const PACKAGE_NAME = '@tinijs/core';
export const PACKAGE_PREFIX = 'tini';

export const APP_ROOT = 'app-root';
export const SPLASHSCREEN_ID = 'splashscreen';
